@if (typeData) {
    <!-- the types to focus on: a small card each, with its icon, number and name -->
    <div class="type-container" role="group" aria-label="Node types to focus on">
        @for (element of typeData; track element.type; let idx = $index) {
            <button type="button" class="type-tile" [class.selected]="selectedIndex === idx" [attr.aria-pressed]="selectedIndex === idx"
                (click)="selectType(element, idx)" [title]="getName(element) + ': ' + element.number">
                <span class="type-icon"><app-node-svg [type]="element.type" [noText]="true" [height]="28"/></span>
                <span class="type-count">{{element.number | number}}</span>
                <span class="type-name">{{getName(element)}}</span>
            </button>
        }
    </div>
}
